import * as React from 'react';
import { NavLink, useNavigate, } from "react-router-dom-v5-compat";

import { ProgressReportsSidebar, SMALL_ICON_BASE_SRC } from '../../../../Shared/index'

const barGraphIncreasingIconSrc = `${SMALL_ICON_BASE_SRC}/bar-graph-increasing.svg`
const groupIconSrc = `${SMALL_ICON_BASE_SRC}/group.svg`
const accountIconSrc = `${SMALL_ICON_BASE_SRC}/account.svg`

const Sidebar = ({
  classrooms,
  closeMobileSidebar,
  showMobileSidebar,
  showSidebarButton,
  selectedClassroomId,
  setSelectedClassroom
}) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!selectedClassroomId) { return }

    const updatedPath = location.pathname.replace(
      /\/classroom\/\d+/,
      `/classroom/${selectedClassroomId}`
    );

    navigate(updatedPath);
  }, [selectedClassroomId])

  const classroomOptions = classrooms.map(classroom => ({ ...classroom, value: classroom.id, label: classroom.name, }))
  const selectedClassroomOption = classroomOptions.find(opt => opt.value === selectedClassroomId);

  const baseLink = `/teachers/progress_reports/diagnostic_insights/classroom/${selectedClassroomId}`

  const activeClassName = ({ isActive }) => (isActive ? 'active focus-on-light' : 'focus-on-light');

  return (
    <ProgressReportsSidebar
      ariaLabel="Diagnostic Insights Navigation"
      classroomOptions={classroomOptions}
      closeMobileSidebar={closeMobileSidebar}
      onClassroomChange={setSelectedClassroom}
      selectedClassroom={selectedClassroomOption}
      showMobileSidebar={showMobileSidebar}
      showSidebarButton={showSidebarButton}
    >
      <div className="sidebar-section">
        <nav aria-labelledby="historyAndRecommendationsTitle">
          <h2 id="historyAndRecommendationsTitle">History & Recommendations</h2>
          <NavLink className={activeClassName} to={`${baseLink}/history_and_recommendations/by_class`}><img alt="" src={groupIconSrc} />By Class</NavLink>
          <NavLink className={activeClassName} to={`${baseLink}/history_and_recommendations/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
        </nav>
      </div>
      <div className="sidebar-section">
        <nav aria-labelledby="performanceInsightsTitle">
          <h2 id="performanceInsightsTitle">Performance Insights</h2>
          <NavLink className={activeClassName} to={`${baseLink}/performance_insights/by_skill`}><img alt="" src={barGraphIncreasingIconSrc} />By Skill</NavLink>
          <NavLink className={activeClassName} to={`${baseLink}/performance_insights/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
        </nav>
      </div>
      <div className="sidebar-section">
        <nav aria-labelledby="practiceInsightsTitle">
          <h2 id="practiceInsightsTitle">Practice Insights</h2>
          <NavLink className={activeClassName} to={`${baseLink}/practice_insights/by_skill`}><img alt="" src={barGraphIncreasingIconSrc} />By Skill</NavLink>
          <NavLink className={activeClassName} to={`${baseLink}/practice_insights/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
        </nav>
      </div>
    </ProgressReportsSidebar>
  )
}

export default Sidebar
